module.exports = __webpack_public_path__ + "static/media/10UNOHRLLS13.95426b97.jpg";